<template>
  <div class="base-tooltip">
    <slot name="activator"></slot>
    <div class="base-tooltip__menu" :style="tooltipMenuStyle">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'BaseTooltip',
  props: {
    text: {
      type: String,
      default: '',
    },
    tooltipMenuStyle: {
      type: [String, Object, Array],
      default: '',
    },
  },
};
</script>
